/**
 * Pastel category colors. Each category gets:
 *  - bg: pale/pastel background
 *  - bgHover: slightly darker pastel for hover
 *  - border: more saturated tone for the card border
 *
 * Used by both POS ItemGrid (item cards + active category tab) and
 * Products list (table rows).
 *
 * Free-dispense items override category colors with intense yellow.
 */

const CATEGORY_PALETTE = {
    ΨΙΛΙΚΑ:     { bg: "#FFE4E6", bgHover: "#FFD1D5", border: "#F472B6" }, // pale rose
    ΑΝΑΨΥΚΤΙΚΑ: { bg: "#DDF2FF", bgHover: "#BDE4FF", border: "#3B9CE3" }, // pale sky
    ΦΑΓΗΤΟ:     { bg: "#FFE8CC", bgHover: "#FFD7A8", border: "#F59E0B" }, // pale orange
    ΚΑΦΕΣ:      { bg: "#EDE0D4", bgHover: "#DCC9B6", border: "#8B6B4F" }, // pale brown
    ΔΙΑΦΟΡΑ:    { bg: "#EAF2EA", bgHover: "#D6E8D6", border: "#6FAE6F" }, // pale sage
};

const FALLBACK = { bg: "#F4F5F7", bgHover: "#E5E7EB", border: "#9CA3AF" };

/** Intense yellow override for free-dispense items. */
export const FREE_DISPENSE_COLORS = {
    bg: "#FFE600",
    bgHover: "#FFD500",
    border: "#B8860B",
};

export function categoryColors(category) {
    return CATEGORY_PALETTE[category] || FALLBACK;
}

/** Resolves the visual colors for an item, applying free-dispense override. */
export function itemColors(item) {
    if (item?.free_dispense) return FREE_DISPENSE_COLORS;
    return categoryColors(item?.category);
}
